import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BoxStyled = styled(Box)`
  background: #fff;
`;
